exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".butter-toast-tray {\n  position: fixed;\n  z-index: 999999;\n  height: 0; }\n  .butter-toast-tray[class*=\"-left\"] {\n    left: 5px; }\n  .butter-toast-tray[class*=\"-right\"] {\n    right: 5px; }\n    .butter-toast-tray[class*=\"-right\"] .wrapper {\n      text-align: right; }\n  .butter-toast-tray[class*=\"-center\"] {\n    left: 50%; }\n    .butter-toast-tray[class*=\"-center\"] .wrapper {\n      text-align: center; }\n  .butter-toast-tray[class*=\"top-\"] {\n    top: 5px; }\n  .butter-toast-tray[class*=\"bottom-\"] {\n    bottom: 5px; }\n  .butter-toast-tray .wrapper {\n    position: relative;\n    padding: 10px; }\n    .butter-toast-tray .wrapper .toast {\n      text-align: left; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/Tray/style.scss
// module id = 125
// module chunks = 0